/* eslint-disable import/no-anonymous-default-export */
import request from "../request";

// Get all templates
const getTemplates = (params = {}) => {
	// Build query string from params object
	const queryParams =
		params && Object.keys(params).length
			? "?" + new URLSearchParams(params).toString()
			: "";
	return request.get(`templates${queryParams}`);
};

// Get single template
const getTemplate = (templateId) => request.get(`templates/${templateId}`);

// Create new template
const createTemplate = (templateData) =>
	request.post("templates", templateData);

// Update template
const updateTemplate = (templateId, templateData) =>
	request.put(`templates/${templateId}`, templateData);

// Delete template
const deleteTemplate = (templateId) =>
	request.delete(`templates/${templateId}`);

// Process letterhead for preview (new templates or preview)
const processLetterhead = (file) => {
	const formData = new FormData();
	formData.append("letterhead", file);

	const config = {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	};

	return request.post("templates/letterhead/process", formData, config);
};

export default {
	getTemplates,
	getTemplate,
	createTemplate,
	updateTemplate,
	deleteTemplate,
	processLetterhead,
};
